import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { MenuSingleSelectItem } from './MenuSingleSelectItem';
import { SearchMenuEmptyState } from './SearchMenuEmptyState';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuSingleSelectList(props) {
    const { renderItem, onSelect, selected, emptyComponent } = props;
    const { items, hasResult, resetSearch } = useSearchableMenu();
    const emptyStateComponent = emptyComponent || <SearchMenuEmptyState />;
    const selectedItem = items.find((item) => item.id === selected);
    const handleOnClick = (item) => {
        onSelect(item);
        resetSearch();
    };
    return (<Fragment>
      {selectedItem && (<Fragment>
          <Menu.Label>
            <Trans comment="Searchable menu - Selected item section title">Selected</Trans>
          </Menu.Label>
          <MenuSingleSelectItem selected>{renderItem(selectedItem)}</MenuSingleSelectItem>
        </Fragment>)}

      {hasResult && (<Fragment>
          <Menu.Label>
            <Trans comment="Searchable menu - Unselected items section title">All items</Trans>
          </Menu.Label>
          {items.map((item) => (<MenuSingleSelectItem key={item.id} onClick={() => handleOnClick(item)}>
              {renderItem(item)}
            </MenuSingleSelectItem>))}
        </Fragment>)}

      {!hasResult && emptyComponent !== false && emptyStateComponent}
    </Fragment>);
}
